import HistoricUsage from './HistoricUsage.component';

export default HistoricUsage;
